(function () {
    'use strict';

    function workflowPhaseIcon() {
        return {
            restrict: 'E',
            scope: {
                percentageComplete: '=',
                phaseIndex: '=',
                skipped: '='
            },
            templateUrl: 'workflow/directives/templates/workflowPhaseIcon.html',
            link: function (scope) {

            }
        };
    }

    workflowPhaseIcon.$inject = [];

    angular.module('ecap.workflow').directive('workflowPhaseIcon', workflowPhaseIcon);
})();
